import React, { memo } from "react";
import { default as WTabs } from "@mui/material/Tabs";

const Tabs = memo((props) => {
  return <WTabs {...props} />;
});

export default Tabs;
